import $ from 'jquery';

export default {
  init() {
    const $section = $('.blog-article-list[data-post-type="pb_news_press"]');
    if (!$section.length) return;

    const $grid = $('#pb-news-grid');
    const $gridInner = $grid.find('.pb-news-grid__inner');
    const $loader = $grid.find('.pb-news-loader');
    const $pagination = $('#pb-news-pagination');
    const $search = $('#pb-news-search');
    const $type = $('#pb-news-type');
    const $reset = $('.reset-filters');

    if (!$grid.length || !$gridInner.length || !$loader.length) {
      return;
    }

    let currentPage = 1;
    const perPage = 10;

    const updateTypeState = () => {
      const hasValue = Boolean($type.val());
      $type.toggleClass('has-selection', hasValue);
    };

    updateTypeState();

    /**
     * Scroll back to top of component
     */
    function scrollToTop() {
      $('html, body').animate(
        {
          scrollTop: $section.offset().top - 40,
        },
        400
      );
    }

    function loadResults(page = 1) {
      currentPage = page;

      const searchVal = $search.val() || '';
      const typeVal = $type.val() || '';

      $.ajax({
        url: window.ajaxurl || '/wp-admin/admin-ajax.php',
        type: 'POST',
        dataType: 'json',
        data: {
          action: 'pb_news_press_query',
          paged: page,
          per_page: perPage,
          s: searchVal,
          press_type: typeVal,
        },
        beforeSend() {
          $grid.addClass('is-loading');
        },
        success(res) {
          if (res.success) {
            $gridInner.html(res.data.html);
            $pagination.html(res.data.pagination);

            if (window.AOS) AOS.refresh();

            const active = searchVal.length || typeVal.length;
            $reset.toggle(!!active);
          }
        },
        complete() {
          $grid.removeClass('is-loading');
        },
      });
    }

    // Initial load
    loadResults(1);

    // Pagination clicks
    $pagination.on('click', 'a:not(.inactive)', function (e) {
      e.preventDefault();

      const page = $(this).data('page');
      if (!page) return;

      loadResults(page);
      scrollToTop();
    });

    // Search (keypress)
    let searchTimer;
    $search.on('keyup', function () {
      clearTimeout(searchTimer);
      searchTimer = setTimeout(() => loadResults(1), 300);
    });

    // Taxonomy filter
    $type.on('change', () => {
      updateTypeState();
      loadResults(1);
    });

    // Reset
    $reset.on('click', function (e) {
      e.preventDefault();
      $search.val('');
      $type.val('');
      updateTypeState();
      loadResults(1);
      $reset.hide();
      scrollToTop();
    });
  },
};
